import Box from '@mui/material/Box';
import { css, type SxProps, styled } from '@mui/material/styles';
import { type HighlightPhraseProps, prepareHighlightedPhrase } from '@openx/utils/lib/prepareHighlightedPhrase';
import { useMemo } from 'react';

const StyledSpan = styled('span')<{ isHighlighted: boolean }>`
  ${({ isHighlighted, theme }) =>
    isHighlighted &&
    css`
      background-color: ${theme.palette.primary.disabled};
    `}
`;

export type HighlightedPhraseProps = {
  children: string;
  'data-test'?: string;
  searchPhrase?: HighlightPhraseProps;
  sx?: SxProps;
};

export const HighlightedPhrase = ({
  children = '',
  'data-test': dataTest,
  searchPhrase,
  sx,
}: HighlightedPhraseProps) => {
  const highlightedChunks = useMemo(() => prepareHighlightedPhrase(children, searchPhrase), [children, searchPhrase]);

  return (
    <Box component="span" data-test={dataTest} sx={sx}>
      {highlightedChunks.map((chunk, index) => (
        <StyledSpan
          isHighlighted={chunk.highlighted}
          data-test={chunk.highlighted ? 'highlighted' : undefined}
          key={index}
        >
          {chunk.content}
        </StyledSpan>
      ))}
    </Box>
  );
};
